module.exports = __webpack_public_path__ + "static/img/齿直角方式蜗杆蜗轮的计算.60578e3d.jpg";